import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink as RouterLink } from 'react-router-dom';
import { isCenterSelected as isCenterSelectedSelector, isDoctorSelected as isDoctorSelectedSelector } from 'src/store/selectors/entity';
import { isAssistant as isAssistantSelector, isDoctor as isDoctorSelector } from 'src/store/selectors/user';
import get from 'lodash/get';

const ToolbarActions = () => {
  const { t } = useTranslation('demands');
  const isAssistant = useSelector(isAssistantSelector);
  const isDoctor = useSelector(isDoctorSelector);
  const isDoctorSelected = useSelector(isDoctorSelectedSelector);
  const isCenterSelected = useSelector(isCenterSelectedSelector);
  const appState = useSelector((state) => state.app);
  const companyId = get(appState, 'data.id');

  const canCreateDemand = ((isAssistant && isDoctorSelected && isCenterSelected) || (isDoctor && isCenterSelected)) && companyId !== 1;

  return (
    <Box display="flex" justifyContent="flex-end">
      {canCreateDemand ? (
        <Button color="primary" variant="contained" component={RouterLink} to="/app/demands/create">
          {t('buttons.create_demand')}
        </Button>
      ) : null}
    </Box>
  );
};

ToolbarActions.propTypes = {};

export default ToolbarActions;
